import React from "react";
import PropTypes from "prop-types";

import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Button
} from "reactstrap";

class AdminHeader extends React.Component {
  getDisplayName() {
    if(localStorage.getItem('account_obj') === null) {
      return '';
    }

    let accountObj = localStorage.getItem('account_obj');

    accountObj = JSON.parse(accountObj);

    return accountObj.display_name;
  }

  logoutUser() {
    localStorage.removeItem('account_obj');
    localStorage.removeItem('secret_token');

    this.props.history.push('/auth/login');
  }

  navigate(path) {
    this.props.history.push(path);
  }

  render() {
    return (
      <>
        <header className="my-3 my-md-4">
          <Container>
            <Row>

              <Col xs="5">
                <Breadcrumb className="breadcrumbs">
                  <BreadcrumbItem className="d-none d-md-block" onClick={(this.props.items[0].path ? this.navigate.bind(this, this.props.items[0].path) : null)}>
                    <h2 className={(this.props.items[0].path ? 'breadcrumbs__link' : '')}>
                      {(this.props.items[0].path &&
                        <i className="ni ni-bold-left breadcrumbs__icon"></i>
                      )}
                      {this.props.items[0].name}
                    </h2>
                  </BreadcrumbItem>
                  <BreadcrumbItem aria-current="page" className="active">
                    {this.props.items[1].name}
                  </BreadcrumbItem>
                </Breadcrumb>
              </Col>

              <Col xs="7" className="d-flex justify-content-end">
                <div className="d-inline-block pt-md-2">
                  <span className="font-weight-bold text-sm">{this.getDisplayName()}</span> <Button className="btn-sm ml-3" color="secondary" type="button" onClick={this.logoutUser.bind(this)}>Uitloggen</Button>
                </div>
              </Col>

            </Row>

            <Row>
              <Col xs="12">
                <hr className="mt-3 mt-md-2 mb-4" />
              </Col>
            </Row>

          </Container>
        </header>
      </>
    );
  }
}

export default AdminHeader;
